import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'ticketEmailTime',
})
export class TicketEmailTimePipe implements PipeTransform {
    transform(date: string | Date): string {
        if (date) {
            const dateObject = new Date(date);
            const isDateInvalid = isNaN(dateObject.getTime());

            if (isDateInvalid) {
                return '';
            }

            const today = new Date();

            const year = dateObject.getFullYear();
            const month = dateObject.getMonth();
            const day = dateObject.getDate();

            if (today.getFullYear() === year && today.getMonth() === month && today.getDate() === day) {
                return formatDate(dateObject, 'HH:mm', 'en-US');
            }

            return formatDate(dateObject, 'dd.MM.yyyy HH:mm', 'en-US');
        } else {
            return '';
        }
    }
}
